import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from '../../../../src/client/App'

import createAuthRequiredPage from "./auth/pages/createAuthRequiredPage"

import LandingPage from '../../../../src/landing-page/LandingPage'
import LoginPage from '../../../../src/auth/LoginPage'
import { Signup as SignupPage } from '../../../../src/auth/SignupPage'
import { RequestPasswordResetPage } from '../../../../src/auth/email-and-pass/RequestPasswordResetPage'
import { PasswordResetPage } from '../../../../src/auth/email-and-pass/PasswordResetPage'
import { EmailVerificationPage } from '../../../../src/auth/email-and-pass/EmailVerificationPage'
import { PrivacyPage } from '../../../../src/client/static-pages/PrivacyPage'
import { TermsPage } from '../../../../src/client/static-pages/TermsPage'
import { ContactPage } from '../../../../src/client/static-pages/ContactPage'
import AboutPage from '../../../../src/client/static-pages/AboutPage'
import AccountPage from '../../../../src/user/AccountPage'
import ReceptionPage from '../../../../src/gedoba/reception/ReceptionPage'
import MyBuildingsPage from '../../../../src/gedoba/platform-identity/MyBuildingsPage'
import OnboardingPage from '../../../../src/gedoba/onboarding/OnboardingPage'
import DemoSchedulerPage from '../../../../src/dashboard/DemoAppPage'
import PricingPage from '../../../../src/payment/PricingPage'
import CheckoutPage from '../../../../src/payment/CheckoutPage'
import FileUploadPage from '../../../../src/file-upload/FileUploadPage'
import AnalyticsDashboardPage from '../../../../src/admin/dashboards/analytics/AnalyticsDashboardPage'
import AdminUsersPage from '../../../../src/admin/dashboards/users/UsersDashboardPage'
import AdminUserDetailPage from '../../../../src/admin/dashboards/users/UserDetailPage'
import AdminUserEditPage from '../../../../src/admin/dashboards/users/UserEditPage'
import AdminSettingsPage from '../../../../src/admin/elements/settings/SettingsPage'
import AdminCalendarPage from '../../../../src/admin/elements/calendar/CalendarPage'
import AdminUIButtonsPage from '../../../../src/admin/elements/ui-elements/ButtonsPage'
import AdminDomainsPage from '../../../../src/admin/dashboards/domains/DomainsPage'
import AdminGeoBlockingPage from '../../../../src/admin/dashboards/geoblocking/GeoBlockingPage'
import AdminMessagesPage from '../../../../src/admin/dashboards/messages/MessagesPage'
import TestDashboardPage from '../../../../src/gedoba/TestDashboardPage'
import LocationLandingPage from '../../../../src/gedoba/location/LocationLandingPage'
import LocationDashboardPage from '../../../../src/gedoba/location/LocationDashboardPage'
import AdminLocationsPage from '../../../../src/gedoba/location/AdminLocationsPage'
import AdminLocationEntriesPage from '../../../../src/gedoba/location/AdminLocationEntriesPage'
import CreateLocationPage from '../../../../src/gedoba/location/CreateLocationPage'
import EditLocationPage from '../../../../src/gedoba/location/EditLocationPage'
import AdminAccessRequestsPage from '../../../../src/gedoba/membership/AdminAccessRequestsPage'
import BmAccessPage from '../../../../src/gedoba/building-management/BmAccessPage'
import AdminLocationTypesPage from '../../../../src/gedoba/location-types/AdminLocationTypesPage'
import AdminSectionFieldVisibilityPage from '../../../../src/gedoba/section-visibility/AdminSectionFieldVisibilityPage'
import AdminPlatformSectionVisibilityPage from '../../../../src/gedoba/section-visibility/AdminPlatformSectionVisibilityPage'
import CreateLocationTypePage from '../../../../src/gedoba/location-types/CreateLocationTypePage'
import EventsPage from '../../../../src/gedoba/events/EventsPage'
import AddEventPage from '../../../../src/gedoba/events/AddEventPage'
import EditEventPage from '../../../../src/gedoba/events/EditEventPage'
import ViewEventPage from '../../../../src/gedoba/events/ViewEventPage'
import TenantsPage from '../../../../src/gedoba/tenants/TenantsPage'
import AddTenantPage from '../../../../src/gedoba/tenants/AddTenantPage'
import EditTenantPage from '../../../../src/gedoba/tenants/EditTenantPage'
import ViewTenantPage from '../../../../src/gedoba/tenants/ViewTenantPage'
import NoticeBoardPage from '../../../../src/gedoba/notice-board/NoticeBoardPage'
import AddNoticePage from '../../../../src/gedoba/notice-board/AddNoticePage'
import EditNoticePage from '../../../../src/gedoba/notice-board/EditNoticePage'
import ViewNoticePage from '../../../../src/gedoba/notice-board/ViewNoticePage'
import FacilitiesPage from '../../../../src/gedoba/facilities/components/FacilitiesPage'
import AddFacilityPage from '../../../../src/gedoba/facilities/components/AddFacilityPage'
import EditFacilityPage from '../../../../src/gedoba/facilities/components/EditFacilityPage'
import ViewFacilityPage from '../../../../src/gedoba/facilities/components/ViewFacilityPage'
import BuySellPage from '../../../../src/gedoba/buy-sell/BuySellPage'
import AddBuySellPage from '../../../../src/gedoba/buy-sell/AddBuySellPage'
import EditBuySellPage from '../../../../src/gedoba/buy-sell/EditBuySellPage'
import ViewBuySellPage from '../../../../src/gedoba/buy-sell/ViewBuySellPage'
import FoodCourtPage from '../../../../src/gedoba/food-court/FoodCourtPage'
import AddFoodCourtPage from '../../../../src/gedoba/food-court/AddFoodCourtPage'
import EditFoodCourtPage from '../../../../src/gedoba/food-court/EditFoodCourtPage'
import ViewFoodCourtPage from '../../../../src/gedoba/food-court/ViewFoodCourtPage'
import TextbooksPage from '../../../../src/gedoba/textbooks/TextbooksPage'
import AddTextbookPage from '../../../../src/gedoba/textbooks/AddTextbookPage'
import ViewTextbookPage from '../../../../src/gedoba/textbooks/ViewTextbookPage'
import EditTextbookPage from '../../../../src/gedoba/textbooks/EditTextbookPage'
import AccommodationPage from '../../../../src/gedoba/accommodation/AccommodationPage'
import AddAccommodationPage from '../../../../src/gedoba/accommodation/AddAccommodationPage'
import ViewAccommodationPage from '../../../../src/gedoba/accommodation/ViewAccommodationPage'
import EditAccommodationPage from '../../../../src/gedoba/accommodation/EditAccommodationPage'
import RequestOfferPage from '../../../../src/gedoba/request-offer/RequestOfferPage'
import AddRequestOfferPage from '../../../../src/gedoba/request-offer/AddRequestOfferPage'
import EditRequestOfferPage from '../../../../src/gedoba/request-offer/EditRequestOfferPage'
import ViewRequestOfferPage from '../../../../src/gedoba/request-offer/ViewRequestOfferPage'
import CarpoolPage from '../../../../src/gedoba/carpooling/CarpoolPage'
import AddCarpoolPage from '../../../../src/gedoba/carpooling/AddCarpoolPage'
import EditCarpoolPage from '../../../../src/gedoba/carpooling/EditCarpoolPage'
import ViewCarpoolPage from '../../../../src/gedoba/carpooling/ViewCarpoolPage'
import LostFoundPage from '../../../../src/gedoba/lost-found/LostFoundPage'
import AddLostFoundPage from '../../../../src/gedoba/lost-found/AddLostFoundPage'
import EditLostFoundPage from '../../../../src/gedoba/lost-found/EditLostFoundPage'
import ViewLostFoundPage from '../../../../src/gedoba/lost-found/ViewLostFoundPage'
import ImmediateHelpPage from '../../../../src/gedoba/immediate-help/ImmediateHelpPage'
import AddImmediateHelpPage from '../../../../src/gedoba/immediate-help/AddImmediateHelpPage'
import EditImmediateHelpPage from '../../../../src/gedoba/immediate-help/EditImmediateHelpPage'
import ViewImmediateHelpPage from '../../../../src/gedoba/immediate-help/ViewImmediateHelpPage'
import AskForHelpPage from '../../../../src/gedoba/ask-for-help/AskForHelpPage'
import AddAskForHelpPage from '../../../../src/gedoba/ask-for-help/AddAskForHelpPage'
import EditAskForHelpPage from '../../../../src/gedoba/ask-for-help/EditAskForHelpPage'
import ViewAskForHelpPage from '../../../../src/gedoba/ask-for-help/ViewAskForHelpPage'
import ShareWithNeighborsPage from '../../../../src/gedoba/share-with-neighbors/ShareWithNeighborsPage'
import AddShareWithNeighborsPage from '../../../../src/gedoba/share-with-neighbors/AddShareWithNeighborsPage'
import EditShareWithNeighborsPage from '../../../../src/gedoba/share-with-neighbors/EditShareWithNeighborsPage'
import ViewShareWithNeighborsPage from '../../../../src/gedoba/share-with-neighbors/ViewShareWithNeighborsPage'
import OtherRequestsPage from '../../../../src/gedoba/other-requests/OtherRequestsPage'
import AddOtherRequestsPage from '../../../../src/gedoba/other-requests/AddOtherRequestsPage'
import EditOtherRequestsPage from '../../../../src/gedoba/other-requests/EditOtherRequestsPage'
import ViewOtherRequestsPage from '../../../../src/gedoba/other-requests/ViewOtherRequestsPage'
import RetailPage from '../../../../src/gedoba/retail/RetailPage'
import AddRetailPage from '../../../../src/gedoba/retail/AddRetailPage'
import EditRetailPage from '../../../../src/gedoba/retail/EditRetailPage'
import ViewRetailPage from '../../../../src/gedoba/retail/ViewRetailPage'
import ServicesPage from '../../../../src/gedoba/services/ServicesPage'
import AddServicePage from '../../../../src/gedoba/services/AddServicePage'
import EditServicePage from '../../../../src/gedoba/services/EditServicePage'
import ViewServicePage from '../../../../src/gedoba/services/ViewServicePage'
import JobsPage from '../../../../src/gedoba/jobs/JobsPage'
import AddJobPage from '../../../../src/gedoba/jobs/AddJobPage'
import EditJobPage from '../../../../src/gedoba/jobs/EditJobPage'
import ViewJobPage from '../../../../src/gedoba/jobs/ViewJobPage'
import BuildingDocumentsPage from '../../../../src/gedoba/building-management/documents/BuildingDocumentsPage'
import WorkOrdersPage from '../../../../src/gedoba/building-management/work-orders/WorkOrdersPage'
import UpkeepRequestsPage from '../../../../src/gedoba/building-management/upkeep/UpkeepRequestsPage'
import BuildingSchedulePage from '../../../../src/gedoba/building-management/schedule/BuildingSchedulePage'
import BuildingSafetyPage from '../../../../src/gedoba/building-management/safety/BuildingSafetyPage'
import PermissionManagementPage from '../../../../src/admin/permissions/PermissionManagementPage'
import ApprovalDashboardPage from '../../../../src/admin/approvals/ApprovalDashboardPage'
import RecycleBinPage from '../../../../src/admin/recycle-bin/RecycleBinPage'
import AdminReportsPage from '../../../../src/admin/dashboards/reports/ReportsPage'
import AdminGlobalSettingsPage from '../../../../src/admin/dashboards/global-settings/GlobalSettingsPage'
import { MaintenancePage } from '../../../../src/client/components/MaintenancePage'
import { NotFoundPage } from '../../../../src/client/components/NotFoundPage'


import { DefaultRootErrorBoundary } from './components/DefaultRootErrorBoundary'

import { routes } from 'wasp/client/router'

export const routeNameToRouteComponent = {
  LandingPageRoute: LandingPage,
  LoginRoute: LoginPage,
  SignupRoute: SignupPage,
  RequestPasswordResetRoute: RequestPasswordResetPage,
  PasswordResetRoute: PasswordResetPage,
  EmailVerificationRoute: EmailVerificationPage,
  PrivacyRoute: PrivacyPage,
  TermsRoute: TermsPage,
  ContactRoute: ContactPage,
  AboutRoute: AboutPage,
  AccountRoute: createAuthRequiredPage(AccountPage),
  DashboardRoute: createAuthRequiredPage(ReceptionPage),
  MyBuildingsRoute: createAuthRequiredPage(MyBuildingsPage),
  OnboardingRoute: createAuthRequiredPage(OnboardingPage),
  DemoSchedulerRoute: createAuthRequiredPage(DemoSchedulerPage),
  PricingPageRoute: PricingPage,
  CheckoutRoute: createAuthRequiredPage(CheckoutPage),
  FileUploadRoute: createAuthRequiredPage(FileUploadPage),
  AdminRoute: createAuthRequiredPage(AnalyticsDashboardPage),
  AdminUsersRoute: createAuthRequiredPage(AdminUsersPage),
  AdminUserDetailRoute: createAuthRequiredPage(AdminUserDetailPage),
  AdminUserEditRoute: createAuthRequiredPage(AdminUserEditPage),
  AdminSettingsRoute: createAuthRequiredPage(AdminSettingsPage),
  AdminCalendarRoute: createAuthRequiredPage(AdminCalendarPage),
  AdminUIButtonsRoute: createAuthRequiredPage(AdminUIButtonsPage),
  AdminDomainsRoute: createAuthRequiredPage(AdminDomainsPage),
  AdminGeoBlockingRoute: createAuthRequiredPage(AdminGeoBlockingPage),
  AdminMessagesRoute: createAuthRequiredPage(AdminMessagesPage),
  TestDashboardRoute: TestDashboardPage,
  LocationLandingRoute: LocationLandingPage,
  LocationDashboardRoute: createAuthRequiredPage(LocationDashboardPage),
  AdminLocationsRoute: createAuthRequiredPage(AdminLocationsPage),
  AdminLocationEntriesRoute: createAuthRequiredPage(AdminLocationEntriesPage),
  CreateLocationRoute: createAuthRequiredPage(CreateLocationPage),
  EditLocationRoute: createAuthRequiredPage(EditLocationPage),
  AdminAccessRequestsRoute: createAuthRequiredPage(AdminAccessRequestsPage),
  BmAccessRoute: createAuthRequiredPage(BmAccessPage),
  LocationBmAccessRoute: createAuthRequiredPage(BmAccessPage),
  AdminLocationTypesRoute: createAuthRequiredPage(AdminLocationTypesPage),
  AdminSectionFieldVisibilityRoute: createAuthRequiredPage(AdminSectionFieldVisibilityPage),
  AdminPlatformSectionVisibilityRoute: createAuthRequiredPage(AdminPlatformSectionVisibilityPage),
  CreateLocationTypeRoute: createAuthRequiredPage(CreateLocationTypePage),
  EventsRoute: createAuthRequiredPage(EventsPage),
  LocationEventsRoute: createAuthRequiredPage(EventsPage),
  AddEventRoute: createAuthRequiredPage(AddEventPage),
  LocationAddEventRoute: createAuthRequiredPage(AddEventPage),
  EditEventRoute: createAuthRequiredPage(EditEventPage),
  LocationEditEventRoute: createAuthRequiredPage(EditEventPage),
  ViewEventRoute: createAuthRequiredPage(ViewEventPage),
  LocationViewEventRoute: createAuthRequiredPage(ViewEventPage),
  TenantsRoute: createAuthRequiredPage(TenantsPage),
  LocationTenantsRoute: createAuthRequiredPage(TenantsPage),
  AddTenantRoute: createAuthRequiredPage(AddTenantPage),
  LocationAddTenantRoute: createAuthRequiredPage(AddTenantPage),
  EditTenantRoute: createAuthRequiredPage(EditTenantPage),
  LocationEditTenantRoute: createAuthRequiredPage(EditTenantPage),
  ViewTenantRoute: createAuthRequiredPage(ViewTenantPage),
  LocationViewTenantRoute: createAuthRequiredPage(ViewTenantPage),
  NoticeBoardRoute: createAuthRequiredPage(NoticeBoardPage),
  LocationNoticeBoardRoute: createAuthRequiredPage(NoticeBoardPage),
  AddNoticeRoute: createAuthRequiredPage(AddNoticePage),
  LocationAddNoticeRoute: createAuthRequiredPage(AddNoticePage),
  EditNoticeRoute: createAuthRequiredPage(EditNoticePage),
  LocationEditNoticeRoute: createAuthRequiredPage(EditNoticePage),
  ViewNoticeRoute: createAuthRequiredPage(ViewNoticePage),
  LocationViewNoticeRoute: createAuthRequiredPage(ViewNoticePage),
  FacilitiesRoute: createAuthRequiredPage(FacilitiesPage),
  LocationFacilitiesRoute: createAuthRequiredPage(FacilitiesPage),
  AddFacilityRoute: createAuthRequiredPage(AddFacilityPage),
  LocationAddFacilityRoute: createAuthRequiredPage(AddFacilityPage),
  EditFacilityRoute: createAuthRequiredPage(EditFacilityPage),
  LocationEditFacilityRoute: createAuthRequiredPage(EditFacilityPage),
  ViewFacilityRoute: createAuthRequiredPage(ViewFacilityPage),
  LocationViewFacilityRoute: createAuthRequiredPage(ViewFacilityPage),
  BuySellRoute: createAuthRequiredPage(BuySellPage),
  LocationBuySellRoute: createAuthRequiredPage(BuySellPage),
  AddBuySellRoute: createAuthRequiredPage(AddBuySellPage),
  LocationAddBuySellRoute: createAuthRequiredPage(AddBuySellPage),
  EditBuySellRoute: createAuthRequiredPage(EditBuySellPage),
  LocationEditBuySellRoute: createAuthRequiredPage(EditBuySellPage),
  ViewBuySellRoute: createAuthRequiredPage(ViewBuySellPage),
  LocationViewBuySellRoute: createAuthRequiredPage(ViewBuySellPage),
  FoodCourtRoute: createAuthRequiredPage(FoodCourtPage),
  LocationFoodCourtRoute: createAuthRequiredPage(FoodCourtPage),
  AddFoodCourtRoute: createAuthRequiredPage(AddFoodCourtPage),
  LocationAddFoodCourtRoute: createAuthRequiredPage(AddFoodCourtPage),
  EditFoodCourtRoute: createAuthRequiredPage(EditFoodCourtPage),
  LocationEditFoodCourtRoute: createAuthRequiredPage(EditFoodCourtPage),
  ViewFoodCourtRoute: createAuthRequiredPage(ViewFoodCourtPage),
  LocationViewFoodCourtRoute: createAuthRequiredPage(ViewFoodCourtPage),
  TextbooksRoute: createAuthRequiredPage(TextbooksPage),
  LocationTextbooksRoute: createAuthRequiredPage(TextbooksPage),
  AddTextbookRoute: createAuthRequiredPage(AddTextbookPage),
  LocationAddTextbookRoute: createAuthRequiredPage(AddTextbookPage),
  ViewTextbookRoute: createAuthRequiredPage(ViewTextbookPage),
  LocationViewTextbookRoute: createAuthRequiredPage(ViewTextbookPage),
  EditTextbookRoute: createAuthRequiredPage(EditTextbookPage),
  LocationEditTextbookRoute: createAuthRequiredPage(EditTextbookPage),
  AccommodationRoute: createAuthRequiredPage(AccommodationPage),
  LocationAccommodationRoute: createAuthRequiredPage(AccommodationPage),
  AddAccommodationRoute: createAuthRequiredPage(AddAccommodationPage),
  LocationAddAccommodationRoute: createAuthRequiredPage(AddAccommodationPage),
  ViewAccommodationRoute: createAuthRequiredPage(ViewAccommodationPage),
  LocationViewAccommodationRoute: createAuthRequiredPage(ViewAccommodationPage),
  EditAccommodationRoute: createAuthRequiredPage(EditAccommodationPage),
  LocationEditAccommodationRoute: createAuthRequiredPage(EditAccommodationPage),
  RequestOfferRoute: createAuthRequiredPage(RequestOfferPage),
  LocationRequestOfferRoute: createAuthRequiredPage(RequestOfferPage),
  AddRequestOfferRoute: createAuthRequiredPage(AddRequestOfferPage),
  LocationAddRequestOfferRoute: createAuthRequiredPage(AddRequestOfferPage),
  EditRequestOfferRoute: createAuthRequiredPage(EditRequestOfferPage),
  LocationEditRequestOfferRoute: createAuthRequiredPage(EditRequestOfferPage),
  ViewRequestOfferRoute: createAuthRequiredPage(ViewRequestOfferPage),
  LocationViewRequestOfferRoute: createAuthRequiredPage(ViewRequestOfferPage),
  CarpoolRoute: createAuthRequiredPage(CarpoolPage),
  LocationCarpoolRoute: createAuthRequiredPage(CarpoolPage),
  AddCarpoolRoute: createAuthRequiredPage(AddCarpoolPage),
  LocationAddCarpoolRoute: createAuthRequiredPage(AddCarpoolPage),
  EditCarpoolRoute: createAuthRequiredPage(EditCarpoolPage),
  LocationEditCarpoolRoute: createAuthRequiredPage(EditCarpoolPage),
  ViewCarpoolRoute: createAuthRequiredPage(ViewCarpoolPage),
  LocationViewCarpoolRoute: createAuthRequiredPage(ViewCarpoolPage),
  LostFoundRoute: createAuthRequiredPage(LostFoundPage),
  LocationLostFoundRoute: createAuthRequiredPage(LostFoundPage),
  AddLostFoundRoute: createAuthRequiredPage(AddLostFoundPage),
  LocationAddLostFoundRoute: createAuthRequiredPage(AddLostFoundPage),
  EditLostFoundRoute: createAuthRequiredPage(EditLostFoundPage),
  LocationEditLostFoundRoute: createAuthRequiredPage(EditLostFoundPage),
  ViewLostFoundRoute: createAuthRequiredPage(ViewLostFoundPage),
  LocationViewLostFoundRoute: createAuthRequiredPage(ViewLostFoundPage),
  ImmediateHelpRoute: createAuthRequiredPage(ImmediateHelpPage),
  LocationImmediateHelpRoute: createAuthRequiredPage(ImmediateHelpPage),
  AddImmediateHelpRoute: createAuthRequiredPage(AddImmediateHelpPage),
  LocationAddImmediateHelpRoute: createAuthRequiredPage(AddImmediateHelpPage),
  EditImmediateHelpRoute: createAuthRequiredPage(EditImmediateHelpPage),
  LocationEditImmediateHelpRoute: createAuthRequiredPage(EditImmediateHelpPage),
  ViewImmediateHelpRoute: createAuthRequiredPage(ViewImmediateHelpPage),
  LocationViewImmediateHelpRoute: createAuthRequiredPage(ViewImmediateHelpPage),
  AskForHelpRoute: createAuthRequiredPage(AskForHelpPage),
  LocationAskForHelpRoute: createAuthRequiredPage(AskForHelpPage),
  AddAskForHelpRoute: createAuthRequiredPage(AddAskForHelpPage),
  LocationAddAskForHelpRoute: createAuthRequiredPage(AddAskForHelpPage),
  EditAskForHelpRoute: createAuthRequiredPage(EditAskForHelpPage),
  LocationEditAskForHelpRoute: createAuthRequiredPage(EditAskForHelpPage),
  ViewAskForHelpRoute: createAuthRequiredPage(ViewAskForHelpPage),
  LocationViewAskForHelpRoute: createAuthRequiredPage(ViewAskForHelpPage),
  ShareWithNeighborsRoute: createAuthRequiredPage(ShareWithNeighborsPage),
  LocationShareWithNeighborsRoute: createAuthRequiredPage(ShareWithNeighborsPage),
  AddShareWithNeighborsRoute: createAuthRequiredPage(AddShareWithNeighborsPage),
  LocationAddShareWithNeighborsRoute: createAuthRequiredPage(AddShareWithNeighborsPage),
  EditShareWithNeighborsRoute: createAuthRequiredPage(EditShareWithNeighborsPage),
  LocationEditShareWithNeighborsRoute: createAuthRequiredPage(EditShareWithNeighborsPage),
  ViewShareWithNeighborsRoute: createAuthRequiredPage(ViewShareWithNeighborsPage),
  LocationViewShareWithNeighborsRoute: createAuthRequiredPage(ViewShareWithNeighborsPage),
  OtherRequestsRoute: createAuthRequiredPage(OtherRequestsPage),
  LocationOtherRequestsRoute: createAuthRequiredPage(OtherRequestsPage),
  AddOtherRequestsRoute: createAuthRequiredPage(AddOtherRequestsPage),
  LocationAddOtherRequestsRoute: createAuthRequiredPage(AddOtherRequestsPage),
  EditOtherRequestsRoute: createAuthRequiredPage(EditOtherRequestsPage),
  LocationEditOtherRequestsRoute: createAuthRequiredPage(EditOtherRequestsPage),
  ViewOtherRequestsRoute: createAuthRequiredPage(ViewOtherRequestsPage),
  LocationViewOtherRequestsRoute: createAuthRequiredPage(ViewOtherRequestsPage),
  RetailRoute: createAuthRequiredPage(RetailPage),
  LocationRetailRoute: createAuthRequiredPage(RetailPage),
  AddRetailRoute: createAuthRequiredPage(AddRetailPage),
  LocationAddRetailRoute: createAuthRequiredPage(AddRetailPage),
  EditRetailRoute: createAuthRequiredPage(EditRetailPage),
  LocationEditRetailRoute: createAuthRequiredPage(EditRetailPage),
  ViewRetailRoute: createAuthRequiredPage(ViewRetailPage),
  LocationViewRetailRoute: createAuthRequiredPage(ViewRetailPage),
  ServicesRoute: createAuthRequiredPage(ServicesPage),
  LocationServicesRoute: createAuthRequiredPage(ServicesPage),
  AddServiceRoute: createAuthRequiredPage(AddServicePage),
  LocationAddServiceRoute: createAuthRequiredPage(AddServicePage),
  EditServiceRoute: createAuthRequiredPage(EditServicePage),
  LocationEditServiceRoute: createAuthRequiredPage(EditServicePage),
  ViewServiceRoute: createAuthRequiredPage(ViewServicePage),
  LocationViewServiceRoute: createAuthRequiredPage(ViewServicePage),
  JobsRoute: createAuthRequiredPage(JobsPage),
  LocationJobsRoute: createAuthRequiredPage(JobsPage),
  AddJobRoute: createAuthRequiredPage(AddJobPage),
  LocationAddJobRoute: createAuthRequiredPage(AddJobPage),
  EditJobRoute: createAuthRequiredPage(EditJobPage),
  LocationEditJobRoute: createAuthRequiredPage(EditJobPage),
  ViewJobRoute: createAuthRequiredPage(ViewJobPage),
  LocationViewJobRoute: createAuthRequiredPage(ViewJobPage),
  BuildingDocumentsRoute: createAuthRequiredPage(BuildingDocumentsPage),
  LocationBuildingDocumentsRoute: createAuthRequiredPage(BuildingDocumentsPage),
  WorkOrdersRoute: createAuthRequiredPage(WorkOrdersPage),
  LocationWorkOrdersRoute: createAuthRequiredPage(WorkOrdersPage),
  BuildingScheduleRoute: createAuthRequiredPage(BuildingSchedulePage),
  LocationBuildingScheduleRoute: createAuthRequiredPage(BuildingSchedulePage),
  BuildingSafetyRoute: createAuthRequiredPage(BuildingSafetyPage),
  LocationBuildingSafetyRoute: createAuthRequiredPage(BuildingSafetyPage),
  UpkeepRequestsRoute: createAuthRequiredPage(UpkeepRequestsPage),
  LocationUpkeepRequestsRoute: createAuthRequiredPage(UpkeepRequestsPage),
  PermissionManagementRoute: createAuthRequiredPage(PermissionManagementPage),
  ApprovalDashboardRoute: createAuthRequiredPage(ApprovalDashboardPage),
  RecycleBinRoute: createAuthRequiredPage(RecycleBinPage),
  AdminReportsRoute: createAuthRequiredPage(AdminReportsPage),
  AdminGlobalSettingsRoute: createAuthRequiredPage(AdminGlobalSettingsPage),
  MaintenanceRoute: MaintenancePage,
  NotFoundRoute: NotFoundPage,
} as const;

const waspDefinedRoutes = [
]
const userDefinedRoutes = Object.entries(routes).map(([routeKey, route]) => {
  return {
    path: route.to,
    Component: routeNameToRouteComponent[routeKey],
  }
})

const browserRouter = createBrowserRouter([{
  path: '/',
  element: <App />,
  ErrorBoundary: DefaultRootErrorBoundary,
  children: [
    ...waspDefinedRoutes,
    ...userDefinedRoutes,
  ],
}])

export const router = <RouterProvider router={browserRouter} />
